import { render, staticRenderFns } from "./ChatChannel.vue?vue&type=template&id=2e13b00c&"
import script from "./ChatChannel.vue?vue&type=script&lang=ts&"
export * from "./ChatChannel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports